import App from '@/App.vue';
import Router from 'vue-router'
// import '@helper/Global';
import Vue from 'vue';
// import fo_router from './fo_router';
import bo_router from './bo_router';
import VueDirective from '@helper/VueDirective';
// import './registerServiceWorker';

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(Router)

Object.keys(VueDirective).forEach((k)=>{
  Vue.directive(k, VueDirective[k])
})

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      component: () => import('@/layout/BoMain.vue'),
      redirect: {name:'BoLogin'},
      children: bo_router
    },
    // Route Frontend
    // {
    //   path: '/',
    //   component: () => import('@/layout/FoMain.vue'),
    //   redirect: {name:"index"},
    //   children: fo_router
    // }
  ]
})

router.beforeEach((to, from, next) => {
  $("body").attr("page", to.name)
  next()
})

global.App = new Vue({
  router,
  render: h => h(App),
  data(){
    return {
      base: {},
      baseUrl: "",
      var: {loadingOverlay: false},
      page: {filter:{},menuRole(){}},
      user: {menuRole:[],moduleRole:[]},
      fields: {},
      web: {},
      app:{
        path:{
          path:{uploader:{}},
          uploader:{},
        },
        uploader:{}
      },
      width: $(window).width(),
      height: $(window).height(),
    }
  },
  computed:{
    isMobile(){ return this.width < 768 },
  },
  watch:{
    base(v){ global.Base = v },
    page(v){ global.Page = v },
  }
}).$mount('#app')